// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as SavedMethods$OrcaPaymentPage from "../Components/SavedMethods.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as RecoilAtomTypes$OrcaPaymentPage from "../Types/RecoilAtomTypes.bs.js";
import * as SwitchViewButton$OrcaPaymentPage from "../Components/SwitchViewButton.bs.js";

function SavedMethodsWithPaymentForm(props) {
  var setPaymentToken = props.setPaymentToken;
  var selectedOption = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var savedMethodsGroupedByType = Core__Array.reduce(props.savedMethods, {}, (function (acc, savedMethod) {
          var paymentTypeKey = PaymentHelpers$OrcaPaymentPage.getConstructedPaymentMethodName(savedMethod.paymentMethod, Core__Option.getOr(savedMethod.paymentMethodType, "other"));
          var existingMethods = acc[paymentTypeKey];
          if (existingMethods !== undefined) {
            acc[paymentTypeKey] = existingMethods.concat([savedMethod]);
          } else {
            acc[paymentTypeKey] = [savedMethod];
          }
          return acc;
        }));
  var savedMethodsForSelectedOption = Core__Option.getOr(savedMethodsGroupedByType[selectedOption], []);
  var savedMethodsCount = savedMethodsForSelectedOption.length;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.showPaymentMethodsScreen);
  var setShowPaymentMethodsScreen = match$1[1];
  var showPaymentMethodsScreen = match$1[0];
  var shouldShowClickToPayCards = props.isShowPaymentMethodsDependingOnClickToPay && selectedOption === "card";
  var shouldRenderAddMethodsButton = savedMethodsCount > 0 || shouldShowClickToPayCards;
  var firstSavedMethod = savedMethodsForSelectedOption[0];
  var selectedToken = firstSavedMethod !== undefined ? ({
        paymentToken: firstSavedMethod.paymentToken,
        customerId: firstSavedMethod.customerId
      }) : RecoilAtomTypes$OrcaPaymentPage.defaultPaymentToken;
  React.useEffect((function () {
          setPaymentToken(function (param) {
                return selectedToken;
              });
        }), [
        showPaymentMethodsScreen,
        selectedOption
      ]);
  React.useEffect((function () {
          var shouldShowForm = savedMethodsCount === 0;
          setShowPaymentMethodsScreen(function (param) {
                if (shouldShowClickToPayCards) {
                  return false;
                } else {
                  return shouldShowForm;
                }
              });
        }), [
        selectedOption,
        savedMethodsCount
      ]);
  if (showPaymentMethodsScreen) {
    return React.createElement(React.Fragment, {}, props.children, React.createElement(RenderIf$OrcaPaymentPage.make, {
                    condition: shouldRenderAddMethodsButton,
                    children: React.createElement(SwitchViewButton$OrcaPaymentPage.make, {
                          onClick: (function (param) {
                              setShowPaymentMethodsScreen(function (param) {
                                    return false;
                                  });
                            }),
                          icon: React.createElement(Icon$OrcaPaymentPage.make, {
                                name: "circle_dots",
                                size: 20,
                                width: 19
                              }),
                          title: match.localeString.useExistingPaymentMethods,
                          ariaLabel: "Click to use existing payment methods",
                          onKeyDown: (function ($$event) {
                              var key = $$event.key;
                              var keyCode = $$event.keyCode;
                              if (key === "Enter" || keyCode === 13) {
                                return setShowPaymentMethodsScreen(function (param) {
                                            return false;
                                          });
                              }
                              
                            })
                        })
                  }));
  } else {
    return React.createElement(SavedMethods$OrcaPaymentPage.make, {
                paymentToken: props.paymentToken,
                setPaymentToken: setPaymentToken,
                savedMethods: savedMethodsForSelectedOption,
                loadSavedCards: props.loadSavedCards,
                cvcProps: props.cvcProps,
                sessions: props.sessions,
                isClickToPayAuthenticateError: props.isClickToPayAuthenticateError,
                setIsClickToPayAuthenticateError: props.setIsClickToPayAuthenticateError,
                getVisaCards: props.getVisaCards,
                closeComponentIfSavedMethodsAreEmpty: props.closeComponentIfSavedMethodsAreEmpty
              });
  }
}

var make = SavedMethodsWithPaymentForm;

export {
  make ,
}
/* react Not a pure module */
